import {
  IconChildBirth,
  IconChildWedding,
  IconDoctorVisit,
  IconEscort,
  IconFuneral,
  IconMoving,
  IconOfficialProceedings,
  IconPropustka,
  IconWedding
} from 'utils/icons';

// ==============================|| DŮVODY PROPUSTKY - IKONY ||============================== //
// Sdílený zdroj pravdy pro klíč uložený v attendance_propustka_reasons.icon
// (2026-08-30, na výslovné přání uživatele), stejný vzor jako
// utils/verificationReasonIcons.js - admin (PropustkaReasonsManager.jsx) i
// zaměstnanecká místa, kde appka nabízí výběr důvodu propustky
// (AttendanceAccordion.jsx, LeaveRequests.jsx), musí rozumět STEJNÉ sadě
// klíčů.

export const PROPUSTKA_REASON_ICON_OPTIONS = [
  { key: '', label: 'Bez ikony', Icon: null },
  { key: 'doctor_visit', label: 'Vyšetření/ošetření u lékaře', Icon: IconDoctorVisit },
  { key: 'escort', label: 'Doprovod rodinného příslušníka', Icon: IconEscort },
  { key: 'wedding', label: 'Vlastní svatba', Icon: IconWedding },
  { key: 'child_wedding', label: 'Svatba dítěte', Icon: IconChildWedding },
  { key: 'child_birth', label: 'Narození dítěte', Icon: IconChildBirth },
  { key: 'official_proceedings', label: 'Úřední/soudní jednání', Icon: IconOfficialProceedings },
  { key: 'moving', label: 'Stěhování se', Icon: IconMoving },
  { key: 'funeral', label: 'Pohřeb', Icon: IconFuneral },
  { key: 'propustka', label: 'Obecné (propustka)', Icon: IconPropustka }
];

export function propustkaReasonIconFor(key) {
  return PROPUSTKA_REASON_ICON_OPTIONS.find((o) => o.key === key)?.Icon ?? null;
}
